<template>
    <div>
        <v-card>
            <v-card-title>
                <div style="font-size:32px; font-weight: 300;">
                    New Case
                </div>
            </v-card-title>
            <v-spacer/>
            <v-card-text>
                <v-layout row wrap>
                    <v-flex sm12>
                        <v-form>
                            <v-text-field
                                v-model="editcase.case_number"
                                label="Case Number"
                                autofocus
                                :error-messages="validationError && validationError.hasOwnProperty('case_number') ? validationError['case_number'] : []"
                            />
                            <v-spacer />
                            <v-text-field v-model="editcase.case_title" label="Case Title"></v-text-field>
                        </v-form>
                    </v-flex>
                    <v-flex sm12>
                        <v-autocomplete
                            v-if="fromContact"
                            v-model="editcase.case_type"
                            :items="casetypeResults"
                            :search-input.sync="casetypeSearch"
                            label="Casetype"
                            item-text="name"
                            item-value="id"
                            :return-object="false"
                            flat
                            @input="casetypeSearch = ''"
                        >
                            <template slot="no-data">
                                <div
                                    class="autocomplete-no-data"
                                >
                                    <div
                                        v-if="casetypeSearch"
                                    >
                                        <i>No results for '{{ casetypeSearch }}'</i>
                                    </div>
                                    <div
                                        v-else
                                    >
                                        Start typing to search
                                    </div>
                                </div>
                            </template>
                        </v-autocomplete>
                        <v-autocomplete
                            v-if="fromCaseType"
                            v-model="editcase.contact"
                            :items="contactResults"
                            :search-input.sync="contactSearch"
                            label="Contact"
                            item-text="full_name"
                            item-value="id"
                            :return-object="false"
                            flat
                            @input="contactSearch = ''"
                        >
                            <template slot="no-data">
                                <div
                                    class="autocomplete-no-data"
                                >
                                    <div
                                        v-if="contactSearch"
                                    >
                                        <i>No results for '{{ contactSearch }}'</i>
                                    </div>
                                    <div
                                        v-else
                                    >
                                        Start typing to search
                                    </div>
                                </div>
                            </template>
                        </v-autocomplete>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn :disabled="saving" flat color="grey" @click="$router.go(-1)">
                    Cancel
                </v-btn>
                <v-btn :disabled="!canSave, saving" color="blue" flat @click="save(); saving=true">
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import pagination from '@/components/global/pagination'

export default {
    name: 'NewCase',
    data() {
        return {
            editcase: {},
            fromContact: false,
            fromCaseType: false,
            contactResults: [],
            casetypeResults: [],
            contactSearch: null,
            casetypeSearch: null,
            selectedContact: null,
            selectedCasetype: null,
            saving: false,
            validationError: null
        }
    },
    created() {
        if (this.$route.params.contact){
            this.editcase.contact = this.$route.params.contact
            this.fromContact = true
        } else {
            this.editcase.case_type = Number(this.$route.params.id)
            this.fromCaseType = true
        }
    },
    computed: {
        canSave() {
            return !this.saving && this.editcase.contact && this.editcase.case_type 
        },
    },
    watch: {
        contactSearch () {
            if(this.contactSearch){
                this.fetchContacts()
            }
        },
        casetypeSearch () {
            if(this.casetypeSearch){
                this.fetchCaseTypes()
            }
        }
    },
    methods: {
        fetchContacts() {
            api.userform.contact.list({
                search: this.contactSearch
            })
                .then(data => {
                    this.contactResults = data.results
                })
        },
        fetchCaseTypes() {
            api.cases.casetype.list({
                search: this.casetypeSearch
            })
                .then(data => {
                    this.casetypeResults = data.results
                })
        },
        save() {
            this.saving = true
            this.validationError = null
            api.cases.cases.save(this.editcase, true)
                .then((response) => {
                    this.$router.push({ name: 'ContactCaseView', params: { id: response.contact.id, case: response.id }})
                })
                .catch((data) => {
                    this.validationError = data.response.data
                })
                .finally(() => {
                    this.saving = false
                })
        }
    },
}

</script>

<style>

</style>